import { modelFamiliesAndLinesCA, models } from '../constants/vehicles';

export const modelFamiliesOptions = Object.keys(modelFamiliesAndLinesCA).map((family) => ({
  key: family,
  value: family, // this will be sent to the backend
  label: family, // this is the user-facing label
}));

export const modelLinesByFamilyOptions = models.reduce<
  Record<string, { key: string; value: string; label: string }[]>
>((acc, item) => {
  const { model, modelOfInterest, modelDeviation } = item;

  const family = Object.entries(modelFamiliesAndLinesCA).find(([_, lines]) =>
    lines.includes(model),
  )?.[0];

  if (!family) return acc;

  if (!acc[family]) acc[family] = [];

  const compositeCode = `${modelOfInterest}_${modelDeviation}`;

  acc[family].push({
    key: compositeCode,
    value: compositeCode,
    label: model,
  });

  return acc;
}, {});

// Returns a single flat list of options for the requested models
export const getOptionsByCompositeCodes = (targetCodes: string[]) => {
  const options = models.reduce<{ key: string; value: string; label: string }[]>((acc, item) => {
    const { model, modelOfInterest, modelDeviation } = item;

    const compositeCode = `${modelOfInterest}_${modelDeviation}`;

    if (!targetCodes.includes(compositeCode)) return acc;

    acc.push({
      key: compositeCode,
      value: compositeCode,
      label: model,
    });

    return acc;
  }, []);

  // SORT: Order the results to exactly match the index in targetCodes
  return options.sort((a, b) => {
    return targetCodes.indexOf(a.key) - targetCodes.indexOf(b.key);
  });
};
